import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PLATFORM_MODE_STORAGE_KEY, PlatformMode } from 'constants/platformMode'
import * as storage from 'helpers/storage'

const storedMode = storage.get(PLATFORM_MODE_STORAGE_KEY, null)

// ------------------------------------------------------------
const initialState = {
  mode: Object.values(PlatformMode).includes(storedMode) ? storedMode : PlatformMode.TestSmarter,
}

// ------------------------------------------------------------
const localSlice = createSlice({
  name: 'platformMode',
  initialState,
  reducers: {
    setPlatformMode: (state, action: PayloadAction<PlatformMode>) => {
      state.mode = action.payload
    },
  },
})

export const { setPlatformMode } = localSlice.actions

export default localSlice.reducer
